import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'IRDevice',
	friendly_name: 'IR Device',
	family: 'ir_controller',
	modes: {
		ir_controller: {
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				share,
				{
					title: 'settings',
					components: [
						{
							title: 'device_information',
							component: 'device_information',
						},
					],
				},
			],
		},
	},
};
